import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  type CreateWaterfallViewPayload,
  type UpdateWaterfallViewPayload,
  waterfallViewsApi,
} from 'pages/Waterfall/api/waterfallViews';

export const WATERFALL_VIEWS_QUERY_KEY = 'waterfall-views';

export const useWaterfallViews = (companyId?: number | null, measurementDateId: number | null = null) =>
  useQuery({
    queryKey: [WATERFALL_VIEWS_QUERY_KEY, companyId, measurementDateId],
    queryFn: () => waterfallViewsApi.list(companyId ?? undefined, measurementDateId),
    enabled: companyId != null && measurementDateId != null,
  });

export const useCreateWaterfallView = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateWaterfallViewPayload) => waterfallViewsApi.create(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [WATERFALL_VIEWS_QUERY_KEY] }),
  });
};

export const useUpdateWaterfallView = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UpdateWaterfallViewPayload }) =>
      waterfallViewsApi.update(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [WATERFALL_VIEWS_QUERY_KEY] }),
  });
};

export const useDeleteWaterfallView = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => waterfallViewsApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [WATERFALL_VIEWS_QUERY_KEY] }),
  });
};
